// Client state for "View As" (impersonation). The started token is held in
// localStorage and sent as the X-Impersonation header on every backend call (see
// apollo-client). While a session is active the whole app acts as the target,
// because the backend resolves the effective user from that token.

const TOKEN_KEY = "atomic-view-as-token";
const TARGET_KEY = "atomic-view-as-target";

export type ViewAsState = {
  token: string;
  targetEmail: string;
};

export function getViewAs(): ViewAsState | null {
  const token = localStorage.getItem(TOKEN_KEY);
  const targetEmail = localStorage.getItem(TARGET_KEY);
  if (!token) return null;
  return { token, targetEmail: targetEmail ?? "" };
}

export function getViewAsToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function isImpersonating(): boolean {
  return !!localStorage.getItem(TOKEN_KEY);
}

export function setViewAs(state: ViewAsState): void {
  localStorage.setItem(TOKEN_KEY, state.token);
  localStorage.setItem(TARGET_KEY, state.targetEmail);
}

export function clearViewAs(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TARGET_KEY);
}
